export default __webpack_public_path__ + "static/media/cinnamon.d7b88e14.jpeg";